import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`
  padding: 80px 5%;
  background: #fdfdfd;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px; /* Tighter radius */
  padding: 60px 80px;
  text-align: center;
  width: 100%;
  box-shadow: 0 8px 30px rgba(0,0,0,0.06); /* Deeper shadow */

  @media (max-width: 768px) {
    padding: 40px 30px;
  }
`;

const Title = styled.h2`
  color: #25aae3;
  font-family: 'Open Sans', Arial, sans-serif;
  font-size: 34px;
  font-weight: 800;
  margin-bottom: 25px;
  letter-spacing: -0.5px;
`;

const Text = styled.p`
  color: #4a5568; /* better contrast */
  font-size: 17px;
  font-family: 'Open Sans', Arial, sans-serif;
  margin-bottom: 45px;
  line-height: 1.6;
  font-weight: 500;
`;

const Button = styled.a`
  display: inline-block;
  background: #25aae3;
  color: #fff;
  border: none;
  padding: 18px 40px;
  font-size: 15px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(37,170,227,0.3);
  transition: all 0.3s ease;

  &:hover {
    background: #1c94c9;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(37,170,227,0.4);
  }
`;

const Guarantee = () => {
  return (
    <SectionWrapper>
      <Container>
        <Box>
          <Title>7 Day Money Back Guarantee!</Title>
          <Text>We're so sure you'll be happy with our service that we've got you covered for 7 days!</Text>
          <Button href="#pricing">CREATE MY ACCOUNT NOW!</Button>
        </Box>
      </Container>
    </SectionWrapper>
  );
};

export default Guarantee;
